import { Box, Flex, Grid, GridItem, Image } from '@chakra-ui/react';

import { configEnv } from '@libraries/config';
import { memo } from 'react';
import { Form, Slider } from './Partials';

const Login: React.FC = (): JSX.Element => {
  return (
    <Box pos="relative">
      <Box
        display={{
          base: 'none',
          md: 'block',
        }}
        pos="absolute"
        top="40px"
        left="40px"
        zIndex="999"
      >
        <Flex align="center">
          <Image
            src={`${configEnv.assetUrl}/logspace/logo-white.png`}
            alt={configEnv.appName}
            w="200px"
          />
          <Box
            className="logspace-version-white"
            style={{
              marginLeft: '-16px',
              fontWeight: 'bold',
            }}
          >
            v2
          </Box>
        </Flex>
      </Box>
      <Grid
        templateColumns={{
          base: '1fr',
          md: '450px 1fr',
          lg: '550px 1fr',
          xl: '600px 1fr',
        }}
        alignItems="center"
      >
        <GridItem
          display={{
            base: 'none',
            md: 'block',
          }}
        >
          <Slider />
        </GridItem>
        <GridItem
          py="10"
          px={{
            base: '4',
            sm: '10',
            md: '6',
            lg: '10',
            xl: '150px',
          }}
        >
          <Form />
        </GridItem>
      </Grid>
    </Box>
  );
};

export default memo(Login);
